<section class="transaction w-full max-w-2xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">בית כנסת</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <div class="card-2026 space-y-4">
    <!-- Action type badge -->
    <div class="flex items-center justify-between border-b border-ink-100 pb-4">
      <span class="inline-flex items-center gap-2 px-3 py-1 rounded-full text-base font-medium"
            [class.bg-success-soft]="transaction.actionType === 1"
            [class.text-success]="transaction.actionType === 1"
            [class.bg-danger-soft]="transaction.actionType === 2"
            [class.text-danger]="transaction.actionType === 2">
        <i class="material-symbols-outlined text-lg" aria-hidden="true">
          {{ transaction.actionType === 1 ? 'south_east' : 'north_west' }}
        </i>
        {{ transaction.actionType === 1 ? 'הכנסה' : 'הוצאה' }}
      </span>
      <span class="text-base text-ink-500">
        {{ transaction.createdAt | date : 'd בMMM y' : '' : 'he-IL' }}
      </span>
    </div>

    <!-- Amount -->
    <div class="flex flex-col items-center py-3">
      <span class="text-sm font-medium text-ink-500">{{ amountLabel }}</span>
      <span class="text-4xl font-bold money mt-1"
            [class.money--credit]="transaction.actionType === 1"
            [class.money--debt]="transaction.actionType === 2">
        {{ transaction.amountPaid | currency : 'ILS' : 'symbol' : '1.0-2' }}
      </span>
    </div>

    <!-- Details -->
    <dl class="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4 border-t border-ink-100">
      <div>
        <dt class="text-sm font-medium text-ink-500">{{ paymentTypeLabel }}</dt>
        <dd class="text-lg text-ink-800 font-medium mt-1">{{ transaction.paymentType || '—' }}</dd>
      </div>
      <div>
        <dt class="text-sm font-medium text-ink-500">{{ paidToLabel }}</dt>
        <dd class="text-lg text-ink-800 font-medium mt-1">{{ transaction.paidTo || '—' }}</dd>
      </div>
      <div *ngIf="transaction.checkNo">
        <dt class="text-sm font-medium text-ink-500">{{ chekNolabel }}</dt>
        <dd class="text-lg text-ink-800 font-medium mt-1">{{ transaction.checkNo }}</dd>
      </div>
      <div *ngIf="transaction.expenseType">
        <dt class="text-sm font-medium text-ink-500">סוג הוצאה</dt>
        <dd class="text-lg text-ink-800 font-medium mt-1">{{ transaction.expenseType }}</dd>
      </div>
    </dl>

    <!-- Actions -->
    <div class="pt-4 border-t border-ink-100 flex flex-col md:flex-row md:justify-end gap-3">
      <button
        type="button"
        class="btn-2026--danger w-full md:w-auto"
        (click)="onDelete()"
      >
        <i class="material-symbols-outlined" aria-hidden="true">delete</i>
        מחק תנועה
      </button>
    </div>
  </div>
</section>
